import {
    CreateScheduleConfig,
    GetScheduleConfig,
    UpdateScheduleConfig,
} from '@src/services/schedule-config'

export const state = {
    configItems: [],
    configInfo: {},
}

export const getters = {}

export const mutations = {
    ADD_CONFIG_ITEM(state, configItem) {
        state.configItems.unshift(configItem)
    },
    DELETE_ITEM(state, configItemId) {
        state.configItems = state.configItems.filter(({ deleteId }) => {
            return deleteId !== configItemId
        })
    },
    SET_CONFIG_INFO(state, newConfigInfo) {
        state.configInfo = newConfigInfo
    },
    SET_CONFIG_ITEMS(state, newList) {
        state.configItems = newList
    },
    CLEAR_STATE(state) {
        state.configItems = []
        state.configInfo = {}
    },
}

export const actions = {
    addConfigItems({ commit }, configItem) {
        commit('ADD_CONFIG_ITEM', configItem)
    },
    deleteItem({ commit }, configItemId) {
        commit('DELETE_ITEM', configItemId)
    },
    async createScheduleConfig(_, scheduleConfig) {
        const resp = await CreateScheduleConfig(scheduleConfig)
        return resp
    },
    async setScheduleConfigForm({ commit }, scheduleConfigId) {
        const resp = await GetScheduleConfig(scheduleConfigId)
        if (resp.status === 200) {
            commit('SET_CONFIG_INFO', resp.data.data)
        }
        return resp
    },
    setConfigItems({ commit }, configItems) {
        commit('SET_CONFIG_ITEMS', configItems)
    },
    async updateScheduleConfig(_, scheduleConfig) {
        const resp = await UpdateScheduleConfig(scheduleConfig)
        return resp
    },
    clearState({ commit }) {
        commit('CLEAR_STATE')
    },
}
